<template>
  <template v-if="item.component === 'el-cascader'">
    <el-cascader
      :id="item.prop"
      :is="item.component"
      :placeholder="item.placeholder"
      :options="item.options"
      :model-value="value"
      @update:model-value="$emit('update:value', $event)"
      style="width:100%"
      clearable
    />
  </template>
  <template v-else-if="item.component === 'el-date-picker'">
    <el-date-picker
      :id="item.prop"
      :type="item.type"
      :placeholder="item.placeholder"
      :disabled="item.disabled"
      :readonly="item.readonly"
      :model-value="value"
      @update:model-value="$emit('update:value', $event)"
      style="width:100%"
      clearable
    />
  </template>
  <!-- radio 选项 -->
  <template v-else-if="item.component === 'el-radio-group'">
    <el-radio-group
      :id="item.prop"
      :type="item.type"
      :model-value="value"
      :disabled="item.readonly"
      @update:model-value="$emit('update:value', $event)"
    >
      <el-radio
        v-for="(option, optionIndex) in item.options"
        :key="optionIndex"
        :label="option.value"
      >
        {{ option.label }}
      </el-radio>
    </el-radio-group>
  </template>
  <template v-else-if="item.component === 'el-select'">
    <el-select
      :is="item.component"
      :id="item.prop"
      :type="item.type"
      :placeholder="item.placeholder"
      :disabled="item.readonly"
      :readonly="item.readonly"
      :filterable="item.filterable"
      :remote="item.remote"
      :remote-method="item.remoteMethod"
      :loading="item.loading"
      :model-value="value"
      @update:model-value="$emit('update:value', $event)"
      clearable
      style="width:100%"
    >
      <el-option
        v-for="(optionItem, optionIndex) in item.options"
        :key="optionIndex"
        :label="optionItem.label"
        :value="optionItem.value"
      />
    </el-select>
  </template>
  <!-- el-input 单独处理，支持小数位限制 -->
  <template v-else-if="item.component === 'el-input' && (item.decimalPlaces || item.isPositive !== null)">
    <el-input
      :id="item.prop"
      :type="getInputType(item)"
      :placeholder="item.placeholder"
      :disabled="item.disabled"
      :readonly="item.readonly"
      :rows="item.rows"
      :maxlength="item.maxlength"
      :show-word-limit="item.showWordLimit"
      :model-value="value"
      @update:model-value="handleInput"
      clearable
      style="width:100%"
    />
  </template>
  <template v-else>
    <component
      :is="item.component"
      :id="item.prop"
      :type="item.type"
      :placeholder="item.placeholder"
      :min="item.min"
      :max="item.max"
      :disabled="item.disabled"
      :filterable="item.filterable"
      :remote="item.remote"
      :remote-method="item.remoteMethod"
      :loading="item.loading"
      :readonly="item.readonly"
      :rows="item.rows"
      :maxlength="item.maxlength"
      :show-word-limit="item.showWordLimit"
      :model-value="value"
      @update:model-value="$emit('update:value', $event)"
      clearable
      style="width:100%"
    />
  </template>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { formatDecimal } from '@/utils'

export default defineComponent({
  name: 'FormControl',
  props: {
    item: {
      type: Object as PropType<any>,
      required: true
    },
    value: {
      type: [String, Number, Boolean, Array, Date],
      default: undefined
    }
  },
  emits: ['update:value'],
  setup(props, { emit }) {
    const getInputType = (item: any) => {
      // 配置了 decimalPlaces 时，强制用 text，方便控制输入
      if (item.component === 'el-input' && item.decimalPlaces !== undefined) {
        return 'text'
      }
      return item.type
    }

    const handleInput = (val: string | number) => {
      const currentItem = props.item as any
      if (currentItem.component === 'el-input' && currentItem.decimalPlaces != null) {
        const formattedValue = formatDecimal(val, currentItem.decimalPlaces, currentItem.isPositive)
        emit('update:value', formattedValue)
        return
      }

      emit('update:value', val)
    }

    return {
      getInputType,
      handleInput
    }
  }
})
</script>
